/**
 * @class CallsService
 */
function CallsService(callsBackend) {
    let self = this;

    /**
     * Get calls of the Store
     * @return {Array} calls
     * @param phone
     * @param from
     * @param to
     */
    self.getCalls = function (phone, from, to) {
        return callsBackend.getCalls(phone, from, to).then(res => {
            return res.body.calls;
        });
    };

    return self;
}

CallsService.$inject = ['callsBackend'];

angular.module('app.prospection.store.callsService', []).factory('callsService', CallsService);
